import { createContext, use } from "react";

import type { PlantStatus } from "./PlantStatus";

export interface PlantStatusStore {
  // Selector fino: solo notifica a los consumidores de ESA planta (#3365).
  subscribeById: (plantId: string, listener: () => void) => () => void;
  getById: (plantId: string) => PlantStatus | null;
  // Consumidor whole-map (listado de flota): re-render en cualquier evento.
  // getMapSnapshot devuelve un clon cuya identidad cambia con cada evento (para
  // invalidar useMemo aguas abajo) pero es estable entre renders sin eventos.
  subscribeAll: (listener: () => void) => () => void;
  getMapSnapshot: () => Map<string, PlantStatus>;
  error: boolean;
  isLoading: boolean;
}

export const PlantStatusContext = createContext<PlantStatusStore | undefined>(
  undefined,
);

export const usePlantStatusStore = (): PlantStatusStore => {
  const store = use(PlantStatusContext);
  if (store === undefined) {
    throw new Error(
      "usePlantStatusStore must be used within a PlantStatusProvider",
    );
  }
  return store;
};
